import { Badge, Spinner } from '@apollo/orbit';
import React from 'react';

import { useIsCloudEndpointInitiatingContext } from 'src/hooks/useIsCloudEndpointInitiating';

export const InitiatingCloudEndpointBadge = () => {
  const { routerIsInitiating } = useIsCloudEndpointInitiatingContext();

  return routerIsInitiating ? (
    <Badge variant="neutralOutlined" icon={<Spinner size="tiny" />}>
      INITIATING ENDPOINT
    </Badge>
  ) : null;
};
